<template>
  <AuthForm>
    <template v-slot:header>
      <h2 v-translate>Créer un compte</h2>
    </template>

    <form role="form" @submit.prevent="submit">
      <error-messages :errors="errors"></error-messages>
      <div class="row">
        <div class="col-md-6">
          <input
            v-model="credentials.email"
            type="text"
            name="email"
            class="form-control"
            :placeholder="titles.email"
            v-focus
          />
          <br />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <input
            v-model="credentials.password"
            type="password"
            name="password"
            class="form-control"
            :placeholder="titles.password"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <input
            v-model="credentials.password_confirmation"
            type="password"
            name="password_confirmation"
            class="form-control"
            :placeholder="titles.password"
          />
        </div>
        <div class="col-md-4 pl-0 pl-sm-4">
          <a :href="forgotPasswordUrl" class="forgot-password" target="_top" v-translate>Mot de passe oublié ?</a>
        </div>
      </div>
      <div class="submit row align-items-center">
        <div class="col-md-3">
          <input type="submit" :value="titles.submit" />
        </div>
      </div>
    </form>

    <template v-slot:footer>
      <div class="mr-4">
        <h2 v-translate>Vous avez déjà un compte ?</h2>
      </div>
      <div>
        <router-link to="/login" class="create-account-link" v-translate>Se connecter</router-link>
      </div>
      <Gdpr />
    </template>
  </AuthForm>
</template>

<script>
import appUrl from 'lib/appUrl.js';
import { oauthBaseUrl } from 'config';
import AuthForm from './AuthForm.vue';
import ErrorMessages from './ErrorMessages.vue';
import Gdpr from './GDPR.vue';
import { mapState } from 'vuex';

export default {
  name: 'Register',
  components: { AuthForm, ErrorMessages, Gdpr },
  computed: {
    ...mapState('auth', ['errors']),
    titles() {
      return {
        email: this.$gettext('Mail de connexion'),
        password: this.$gettext('Mot de passe'),
        submit: this.$gettext('Créer un compte'),
      };
    },
  },
  methods: {
    async submit() {
      await this.$store.dispatch('auth/register', this.credentials);
    },
  },
  data() {
    return {
      credentials: {
        email: '',
        password: '',
        password_confirmation: '',
      },
      forgotPasswordUrl: `${oauthBaseUrl}users/password/new?callback_url=${appUrl}`,
    };
  },
};
</script>
